import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["ownerCheckbox", "clientCheckbox"]

  selectAllOwners(e){
    if (e.target.checked) {
      this.ownerCheckboxTargets.forEach((e)=> e.checked = true)
      this.clientCheckboxTargets.forEach((e)=> e.checked = true)

    } else {
      this.ownerCheckboxTargets.forEach((e)=> e.checked = false)
      this.clientCheckboxTargets.forEach((e)=> e.checked = false)
    }
  }

  selecetAllClientOwners(e){
    const clientId = e.target.dataset['clientId']
    const ownersonwersByClient = this.onwersByClient(clientId)

    if (e.target.checked) {
      ownersonwersByClient.forEach((e) => e.checked = true)
    } else {
      ownersonwersByClient.forEach((e) => e.checked = false)

    }
  }

  onwersByClient(clientId){
    return this.ownerCheckboxTargets.filter((element) => {
      if(element.dataset['ownerClientId'] === clientId) return element
    })

  }
}